import styled, { css } from 'styled-components';

export const LineListWrapper = styled.div`
    ${({ theme }) => css`
        border: 0.0625rem solid ${theme.colors.secondary.tints[1].hex};
        margin-bottom: 1.5rem;

        @media ${theme.breakpoints.large.media} {
            margin-bottom: 0;
        }
    `}
`;

export const AccreditationsWrapper = styled.ul`
    ${({ theme }) => css`
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        align-items: center;
        justify-content: center;
        gap: 2rem;
        list-style: none;
        padding: 0;
        margin: 0;

        @media ${theme.breakpoints.medium.media} {
            margin: 0.75rem 0;
        }

        @media ${theme.breakpoints.large.media} {
            flex-direction: column;
        }
    `}
`;

export const AccreditationsListItem = styled.li`
    ${({ theme }) => css`
        position: relative;
        width: 100%;
        height: 5.5rem;
        max-width: 12.5rem;

        @media ${theme.breakpoints.large.media} {
            height: 6.3125rem;
            max-width: 17.75rem;
        }
    `}
`;
